/**
 * @generated SignedSource<<3b52e00a4ec17d8de3e2dd8b699d889e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type VideoFileStatus = "ERROR" | "PROCESSING" | "READY" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type postCoverFragment$data = {
  readonly coverContent: {
    readonly __typename: "ExternalVideoCover";
    readonly url: string;
  } | {
    readonly __typename: "ImageFile";
    readonly id: string;
    readonly name: string;
    readonly rawID: string;
    readonly signedUrl: string;
  } | {
    readonly __typename: "VideoFile";
    readonly id: string;
    readonly muxId: string | null | undefined;
    readonly playback: {
      readonly playback: string;
      readonly tokens: {
        readonly playback: string | null | undefined;
        readonly storyboard: string | null | undefined;
        readonly thumbnail: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly rawID: string;
    readonly status: VideoFileStatus;
    readonly thumbnail: {
      readonly signedUrl: string;
    } | null | undefined;
    readonly url: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly id: string;
  readonly " $fragmentType": "postCoverFragment";
};
export type postCoverFragment$key = {
  readonly " $data"?: postCoverFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"postCoverFragment">;
};

import PostCoverContentQuery_graphql from './PostCoverContentQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rawID",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signedUrl",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "playback",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": PostCoverContentQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "postCoverFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "coverContent",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/)
          ],
          "type": "ExternalVideoCover",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v1/*: any*/),
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            (v3/*: any*/)
          ],
          "type": "ImageFile",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v1/*: any*/),
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "muxId",
              "storageKey": null
            },
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ImageFile",
              "kind": "LinkedField",
              "name": "thumbnail",
              "plural": false,
              "selections": [
                (v3/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "VideoPlayback",
              "kind": "LinkedField",
              "name": "playback",
              "plural": false,
              "selections": [
                (v4/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "VideoFileTokens",
                  "kind": "LinkedField",
                  "name": "tokens",
                  "plural": false,
                  "selections": [
                    (v4/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "storyboard",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "thumbnail",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "VideoFile",
          "abstractKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "type": "Post",
  "abstractKey": null
};
})();

(node as any).hash = "a42d08fcad51be2253f6a7469dca818d";

export default node;
